import { render, staticRenderFns } from "./score.html?vue&type=template&id=360574c7&scoped=true&"
import script from "./score.js?vue&type=script&lang=js&"
export * from "./score.js?vue&type=script&lang=js&"
import style0 from "./score.scss?vue&type=style&index=0&id=360574c7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "360574c7",
  null
  
)

export default component.exports